import { generateEncryptionKey } from './crypto';

// Generate a new CSRF token
export const generateCsrfToken = (): string => {
  return generateEncryptionKey();
};

// Validate CSRF token
export const validateCsrfToken = (token: string, storedToken: string): boolean => {
  if (!token || !storedToken) {
    return false;
  }
  return token === storedToken;
};

// Store CSRF token in localStorage
export const storeCsrfToken = (token: string): void => {
  localStorage.setItem('csrf-token', token);
};

// Get stored CSRF token
export const getStoredCsrfToken = (): string | null => {
  return localStorage.getItem('csrf-token');
};

// Add CSRF token to request headers
export const addCsrfHeader = (headers: Record<string, string>): Record<string, string> => {
  const token = getStoredCsrfToken();
  if (token) {
    return {
      ...headers,
      'X-CSRF-Token': token
    };
  }
  return headers;
};